<template>
  <tr>
    <template v-if="(create && !value.id) || edit || bulk">
      <td :colspan="colspan">
        <div class="card">
          <div class="card-header">
            <template v-if="create">Add Student</template>
            <template v-else>Editing Student {{ student.firstName }}</template>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-3" v-for="(property, field) in fields">
                <template v-if="field == 'classId'">
                  <label for="students-edit-classid">{{ labels['classId'] }}</label>
                  <select class="form-control" id="students-edit-classid"
                          :required="isEnabled( 'classId.required')"
                          :disabled="!isEnabled(field)"
                          :class="{'is-invalid': hasError(field)}"
                          v-model.number="student.classId">
                    <option :value="null"></option>
                    <option v-for="schoolClass in classes" :value="schoolClass.id">{{ schoolClass.name }}</option>
                  </select>
                  <div class="invalid-feedback">
                    {{ errorMessage(field) }}
                  </div>
                </template>

                <template v-else-if="field == 'gender'">
                  <label for="students-edit-gender">{{ labels['gender'] }}</label>
                  <select class="form-control" id="students-edit-gender"
                          :required="isEnabled( 'gender.required')"
                          :disabled="!isEnabled(field)"
                          :class="{'is-invalid': hasError(field)}"
                          v-model.number="student.gender">
                    <option value=""></option>
                    <option v-for="(value, gender) in genders" :value="gender">
                      {{ value }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    {{ errorMessage(field) }}
                  </div>
                </template>

                <template v-else-if="field == 'exemption'">
                  <label  for="students-edit-exemption">{{ labels['exemption'] }}</label>
                  <select class="form-control" id="students-edit-exemption"
                          :required="isEnabled( 'exemption.required')"
                          :disabled="!isEnabled(field)"
                          :class="{'is-invalid': hasError(field)}"
                          v-model.number="student.exemption">
                    <option value=""></option>
                    <option v-for="(value, exemption) in exemptions" :value="exemption">
                      {{ value }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    {{ errorMessage(field) }}
                  </div>
                </template>

                <!--<template v-else-if="field == 'indigenous'">-->
                  <!--<label>{{ labels['indigenous'] }}</label>-->
                  <!--<div class="form-check" :class="{'is-invalid': hasError('indigenous')}">-->
                    <!--<input class="form-check-input"-->
                           <!--:required="isEnabled( 'indigenous.required')"-->
                           <!--:disabled="!isEnabled(field)"-->
                           <!--type="checkbox"-->
                           <!--:class="{'is-invalid': hasError(field)}"-->
                           <!--v-model="student.indigenous"-->
                           <!--:placeholder="value.indigenous">-->
                  <!--</div>-->
                  <!--<div class="invalid-feedback">-->
                    <!--{{ errorMessage(field) }}-->
                  <!--</div>-->
                <!--</template>-->

                <template v-else>
                  <label v-bind:for="'students-edit-' + field ">{{ labels[field] }}</label>
                  <input type="text" class="form-control" v-bind:id="'students-edit-' + field "
                         v-model="student[field]"
                         :required="isEnabled( field + '.required')"
                         :disabled="!isEnabled(field)"
                         :class="{'is-invalid': hasError(field)}"
                         :placeholder="value[field]"/>
                  <div class="invalid-feedback">
                    {{ errorMessage(field) }}
                  </div>
                </template>
              </div>
            </div>

            <div class="text-right mt-sm-2" v-if="!bulk">
              <button type="button" class="btn btn-sm btn-outline-secondary" v-on:click="closeForm()">
                Close
              </button>
              <button type="submit" class="btn btn-sm btn-outline-success" v-on:click.prevent="save">
                <i class="fas fa-fw" :class="saving ? 'fa-spinner fa-pulse' : 'fa-save'"></i> Save
              </button>
            </div>
          </div>
        </div>
      </td>
    </template>
    <template v-else-if="view">
      <td colspan="10">
        <view-student v-model="value"
                      :fields="fields"
                      :labels="labels"
                      :classes="classes"
                      :genders="genders"
                      :exemptions="exemptions"
                      :school="school"
                      v-on:cancel="cancel">
        </view-student>
      </td>
    </template>
    <template v-else>
      <td v-for="(property, field) in filteredFields">
        <!--<span v-if="field == 'gender'">{{ gender }}</span>-->
        <span v-if="field == 'classId'">{{ className }}</span>
        <!--<span v-else-if="field == 'exemption'">{{ exemption }}</span>-->
        <span v-else-if="totalFields > colspan && field == 'firstName'">
          <a href="" v-on:click.prevent="view = true">{{ value[field] }}</a>
        </span>
        <!--<span v-else-if="field == 'indigenous'">{{ value[field] ? 'Yes' : 'No'}}</span>-->
        <span v-else>{{ value[field] }}</span>
      </td>

      <th class="text-right float-right">
        <button type="button" class="btn btn-sm btn-outline-secondary" aria-label="Delete" v-if="canDeleteStudent" v-on:click="destroy(value)">
          <i class="fas fa-fw" :class="deleting === value ? 'fa-spinner fa-pulse' : 'fa-trash'"></i>
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary open-form" v-if="canEditStudent" v-on:click="onEdit()">
          <i class="fas fa-fw fa-edit"></i> Edit
        </button>
      </th>
    </template>
  </tr>
</template>
<script>
  export default {
    props: [
      'value',
      'bulk',
      'create',
      'school',
      'fields',
      'labels',
      'errors',
      'classes',
      'genders',
      'exemptions',
      'canEditStudent',
      'canDeleteStudent',
      'colspan'
    ],
    data() {
      return {
        student: {},
        view: false,
        edit: false,
        saving: false,
        deleting: false,
        internalErrors: {}
      };
    },
    methods: {
      onEdit: function() {
        this.openForm();
        this.reset();
        this.edit = true;
      },
      hasError: function(field) {
        return _.has(this.internalErrors, field)
      },
      errorMessage: function(field) {
        return _.get(this.internalErrors, field + '.0');
      },
      isEnabled: function(field) {
        return _.get(this.fields, field + '.enabled');
      },
      save: function() {
        if(_.isEqual(this.value, this.student)) {
          this.reset();
        }

        var self = this;
        var endpoint = this.getEndpoint(this.student);
        this.saving = true;

        axios.post(endpoint, this.student)
          .then(function(response) {
            self.feedback(response.data);
            self.student = response.data;
            self.$emit('input', self.student);
            self.$emit('saved', response);

            self.reset();
          })
          .catch(function(error) {
            self.saving = false;

            if(_.get(error, 'response.status') == 422) {
              self.internalErrors = _.get(error, 'response.data');
              return;
            }

            self.$emit('error', 'saved');
          });
      },
      cancel() {
        this.deleting = false;
        this.saving = false;
        this.edit = false;
        this.view = false;
        this.internalErrors = {};
        this.$emit('cancel');
      },
      openForm: function() {
        let parentElement = $(document.activeElement).closest("tbody");

        setTimeout(function(parentElement) {
            parentElement.find(':input:enabled:visible:first').focus();
        }, 10, parentElement);

        this.cancel();
      },
      closeForm: function() {
          let parentElement = $(document.activeElement).closest("tbody");

          setTimeout(function(parentElement) {
              parentElement.find(".open-form").focus();
          }, 10, parentElement);

          this.cancel();
      },
      reset() {
        this.cancel();
      },
      getEndpoint(student) {
        var id = _.get(student, 'id') ? '/' + _.get(student, 'id') : '';
        var endpoint = '/schools/' + this.school.id + '/students' + id;

        return endpoint;
      },
      feedback: function(student) {
        var self = this;
        this.highlight = student;

        setTimeout(function() {
          self.highlight = false;
        }, 2000);
      },
      destroy: function(student) {
        this.deleting = student;

        if(!confirm('Do you want to delete the student ' + student.firstName + '?')) {
          return this.reset();
        }

        var self = this;
        var endpoint = this.getEndpoint(student);

        axios.delete(endpoint)
          .then(function() {
            self.reset();
            self.$emit('deleted', student);
          })
          .catch(function(error) {
            self.deleting = false;
            self.$emit('error', 'deleted');
          });

      }
    },
    computed: {
      editing() {
        return this.edit || this.bulk;
      },
      filteredFields() {
        var keys = _.keys(this.fields);

        return _.pick(this.fields, _.take(keys, (this.colspan - 1)));
      },
      className() {
        return _.get(_.get(this.classes, this.value['classId']), 'name');
      },
      gender() {
        return _.get(this.genders, this.value['gender']);
      },
      exemption() {
        return _.get(this.exemptions, this.value['exemption']);
      },
      totalFields() {
        return _.size(this.fields);
      }
    },
    watch: {
      editing(editing) {
        if(this.bulk) {
          this.student = this.value;
        } else if(editing) {
          this.student = Object.assign({}, this.value);
        }
      },
      errors(errors) {
        this.internalErrors = errors;
      }
    }

  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/student-form.vue